import {createContainer} from 'unstated-next';
import {useMids} from '../..';

function useMidsProvider() {
  return useMids();
}

export const MidsContainer = createContainer(useMidsProvider);
export const useMidsContainer = MidsContainer.useContainer;
